import React from 'react';
import { Wrench, Instagram, Music2 } from 'lucide-react';

export const Maintenance = ({ message }) => {
  return (
    <div className="min-h-screen bg-black flex items-center justify-center px-5" data-testid="maintenance-page">
      <div className="max-w-2xl text-center">
        {/* Logo */}
        <h1 className="text-[#ff1f4d] text-5xl md:text-7xl font-black mb-2 tracking-widest" style={{ textShadow: '0 0 25px rgba(255,31,77,0.8)' }}>
          2.TURNT
        </h1>
        <p className="text-gray-500 text-sm tracking-[4px] uppercase mb-12">Industries</p>

        {/* Wrench icon */}
        <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-[#ff1f4d]/10 border border-[#ff1f4d]/30 mb-8">
          <Wrench className="h-10 w-10 text-[#ff1f4d]" />
        </div>

        {/* Message */}
        <h2 className="text-4xl md:text-5xl font-black text-white mb-4 uppercase tracking-tight">
          We're Cooking <span className="text-[#ff1f4d]">Something New</span>
        </h2>
        <p className="text-gray-300 text-lg leading-relaxed max-w-md mx-auto mb-10">
          {message || (
            <>
              The store is paused while we process the next drop.
              <br />
              <span className="text-[#ff1f4d] font-bold">Stay turnt.</span> We'll be back soon.
            </>
          )}
        </p>

        {/* Socials */}
        <p className="text-gray-500 text-sm tracking-[3px] uppercase mb-6">Follow for updates</p>
        <div className="flex justify-center gap-8 mb-12">
          <a href="#" className="text-white hover:text-[#ff1f4d] transition-colors flex items-center gap-2" data-testid="maint-instagram">
            <Instagram className="h-5 w-5" />
            <span className="uppercase text-sm tracking-wider font-bold">Instagram</span>
          </a>
          <a href="#" className="text-white hover:text-[#ff1f4d] transition-colors flex items-center gap-2" data-testid="maint-tiktok">
            <Music2 className="h-5 w-5" />
            <span className="uppercase text-sm tracking-wider font-bold">TikTok</span>
          </a>
        </div>

        <p className="text-gray-600 text-xs tracking-[3px] uppercase">
          Faith • Fashion • Streetwear
        </p>
      </div>
    </div>
  );
};
